module.exports = __webpack_public_path__ + "static/media/PATS_3-768w.be53c7b7.webp";